// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ajryw_2bcGQbXlEUqrU9{align-items:center;background-color:var(--pf-background-color);border-radius:3px;box-shadow:0 0 4px 0 rgba(248,236,236,.35);display:flex;height:100%;justify-content:space-between;position:relative}.fnMUkLGC5Mo7qk3RlOB8{justify-content:center}.s4XS73fJrQLibqXDNseB{background-color:#002a32}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `ajryw_2bcGQbXlEUqrU9`,
	"centeredItems": `fnMUkLGC5Mo7qk3RlOB8`,
	"isDark": `s4XS73fJrQLibqXDNseB`
};
export default ___CSS_LOADER_EXPORT___;
